import { Breadcrumbs, Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import useBreadcrumbItems from '@xver/hooks/useBreadcrumbItems';
import usePageHeading from '@xver/hooks/usePageHeading';

import AppearanceSection from './components/AppearanceSection';
import LanguageSection from './components/LanguageSection';
import NotificationsSection from './components/NotificationsSection';
import { useNotificationPreferencesQuery } from './hooks/useNotificationPreferencesQuery';
import { useUpdateNotificationPreferencesMutation } from './hooks/useUpdateNotificationPreferencesMutation';

export default function SettingsPage() {
    const { t } = useTranslation('settings');
    const headingRef = usePageHeading(t('page.title'));
    const { data: preferences, isPending } = useNotificationPreferencesQuery();
    const mutation = useUpdateNotificationPreferencesMutation();

    const breadcrumbItems = useBreadcrumbItems([
        { title: t('breadcrumb.platform'), href: '#' },
        { title: t('breadcrumb.settings') },
    ]);

    return (
        <div className="w-full min-h-full flex flex-col justify-start items-center gap-8">
            <div className="w-full flex flex-col justify-start items-start">
                <Breadcrumbs separatorMargin="xs" className="mb-6">
                    {breadcrumbItems}
                </Breadcrumbs>
                <div className="w-full flex flex-col gap-1">
                    <h1 ref={headingRef} tabIndex={-1} className="text-3xl font-bold">
                        {t('page.title')}
                    </h1>
                    <p className="w-auto max-w-135 text-base text-fg/68">{t('page.description')}</p>
                </div>
            </div>
            <div className="w-full flex flex-col gap-4">
                <AppearanceSection />
                {isPending || !preferences ? (
                    <div className="w-full flex items-center justify-center py-16">
                        <Loader size="md" type="bars" />
                    </div>
                ) : (
                    <>
                        <LanguageSection
                            language={preferences.language}
                            onChange={(next) => mutation.mutate({ language: next })}
                            isSaving={mutation.isPending}
                        />
                        <NotificationsSection
                            preferences={preferences}
                            onToggle={(key, next) => mutation.mutate({ [key]: next })}
                            isSaving={mutation.isPending}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
